import { SWRConfiguration } from 'swr';

import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { EmployeeReadApiClient, People } from '~/services/Http';

export const GET_EMPLOYEE_TEAM_SWR_KEY =
  'EmployeeReadApiClient.getEmployeeTeam';

export function useGetEmployeeTeam(
  args: {
    employeeId: string;
    lang?: string;
    offset?: number;
    limit?: number;
    order?: People.Order6;
    treeId?: string;
    unitIds?: number[];
    roles?: string[];
  },
  swrConfig?: SWRConfiguration<People.TeamMemberDto[]>,
  disable?: boolean,
): UseSWROutput<People.TeamMemberDto[]> {
  return useSWR(
    !disable
      ? [
          GET_EMPLOYEE_TEAM_SWR_KEY,
          args.employeeId,
          args?.lang ?? undefined,
          args?.offset ?? undefined,
          args?.limit ?? undefined,
          args?.order ?? undefined,
          args?.treeId ?? undefined,
          args?.unitIds ?? undefined,
          args?.roles ?? undefined,
        ]
      : null,
    ([_, employeeId, lang, offset, limit, order, treeId, unitIds, roles]) =>
      EmployeeReadApiClient.getEmployeeTeam(
        employeeId,
        order,
        offset,
        limit,
        lang,
        treeId,
        roles,
        unitIds,
      ).then((r) => r.data),
    swrConfig,
  );
}
